import React, { useEffect } from "react";

import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import ContentShimmer from "react-content-shimmer";

import VerificationLayout from "../component/layout/VerificationLayout.component";
import { useVerification } from "../context/Verification.context";
import GetUserDetails from "../component/base/GetUserDetails.component";
import { useAuth } from "../context/Auth.context";
import { FETCH_VERIFICATION_URL } from "../graphql/query/query";

const GetUserDetailsPage = () => {
  const params = useParams();
  const verification = useVerification();
  const auth = useAuth();

  const { data, loading, error } = useQuery(FETCH_VERIFICATION_URL, {
    variables: {
      verificationInput: {
        employee_user_id: params?.spid,
        dealership_id: params?.dealershipId,
      },
    },
  });

  useEffect(() => {
    if (data?.fetchVerificationUrl) {
      let getImage = data?.fetchVerificationUrl?.image_url;
      verification.setDealershipLogo(getImage);
    }
  }, [data]);

  useEffect(() => {
    verification.setEmployeeId(params.spid);
    verification.setDealershipId(params.dealershipId);
  }, []);
  return (
    <>
      <VerificationLayout>
        <Box
          display={"flex"}
          justifyContent={"center"}
          flexDirection={"column"}
          width={{
            xs: 300, //0 - 600
            sm: 300, //600-960
            md: 360, //960-1280
            lg: 600, //1280 above
          }}
          height={{
            xs: 600,
            sm: 400,
            md: 600,
            lg: 1200,
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="flex-end"
            gap="8px"
            marginTop="8px"
            marginBottom="8px"
          >
            {!verification?.dealershipLogo || loading ? (
              <ContentShimmer
                size={{
                  height: window.innerWidth <= 750 ? 30 : 60,
                  width: window.innerWidth <= 750 ? 90 : 150,
                }}
              />
            ) : (
              <img
                src={verification?.dealershipLogo}
                width={100}
                height={60}
                alt="logo"
                style={{
                  objectFit: "contain",
                }}
              />
            )}
          </Box>

          <Typography
            variant="p"
            align="center"
            style={{ marginBottom: "10px" }}
          >
            Please enter your details
          </Typography>
          <GetUserDetails isURL={true} />
        </Box>
      </VerificationLayout>
    </>
  );
};

export default GetUserDetailsPage;
